import * as React from 'react';
import InputText from '../../../../../common/components/InputText';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import DatePicker from '../../../../../common/components/DatePicker';
import Button from '../../../../../common/components/Button';
import {LOAN_APPLICATION_MX, LOAN_APPLICATION, GLOBAL} from '../../../../constants/LabelConstants';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import AssetsManager from '../../../../../common/utils/AssetsManager';
import {PersonalDataStepProps, PersonalDataStepState} from '../../../../types/mx/creditoReal/components';
import Checkbox from '../../../../../common/components/Checkbox';
import SelectSearchComponent from '../../../../../common/components/SelectSearchComponent';
import Options from '../../../../../common/components/Options';
import * as OrientationTypes from '../../../../../common/components/OrientationTypes';

class PersonalDataStepView extends React.Component<PersonalDataStepProps, PersonalDataStepState> {
    constructor(props) {
        super(props);
        this.state = {
            showErrors: false
        };
        this.props.getLoanApplication();
    }

    componentDidMount() {
        setTimeout(() => {
            window.scrollTo({left: 0, top: 0, behavior: 'smooth'});
        }, 200);
    }

    onPressNext = () => {
        this.setState({showErrors: true}, this.checkIfPressNext);
    }

    checkIfPressNext = () => {
        if (this.props.personalDataFieldsHasError) {
            return this.props.onPressNext();
        }
    }

    renderMessage = () =>
        <div className="row bg-light border rounded mx-1 mt-4 mb-3">
            <div className="col-2 pl-1 pr-1 text-center mt-3 mb-3">
                <img src={AssetsManager('/assets/images/wizard/identity-verification-icon.svg')}
                     alt="" className="img-fluid"/>
            </div>
            <div className="col-10 mt-3 mb-3">
                {LOAN_APPLICATION_MX.IDENTITY_VALIDATION_MSG}
            </div>
        </div>

    onChangeReceiveNewsPromotions = value => this.props.onChangeReceiveNewsPromotions(value);

    render() {
        const receiveNewsPromotionsOptions = [{
            id: '1',
            value: this.props.receiveNewsPromotions,
            label: LOAN_APPLICATION_MX.RECEIVE_NEWS_PROMOTIONS_OPTION,
            defaultChecked: this.props.receiveNewsPromotions
        }];
        return (
            <React.Fragment>

                <div className="row mb-3 d-none d-sm-none d-md-block">
                    <div className="col">
                        <h3 className="text-raleway text-secondary-lighten-1">{LOAN_APPLICATION.APPLICANT_DATA}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col mb-2">
                        <p>{LOAN_APPLICATION_MX.APPLICANT_DATA_MESSAGE}</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.FIRST_NAME}
                                           id={INPUTS.FIRST_NAME}
                                           value={this.props.firstNameField.value}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.props.firstNameField.error}
                                           onChange={this.props.onChangeFirstName}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.SECOND_NAME}
                                           id={INPUTS.SECOND_NAME}
                                           value={this.props.secondNameField.value}
                                           hasError={this.state.showErrors}
                                           labelError={this.props.secondNameField.error}
                                           onChange={this.props.onChangeSecondName}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.LAST_NAME}
                                           id={INPUTS.LAST_NAME}
                                           value={this.props.lastNameField.value}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.props.lastNameField.error}
                                           onChange={this.props.onChangeLastName}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.SECOND_LAST_NAME}
                                           id={INPUTS.SECOND_LAST_NAME}
                                           value={this.props.secondLastNameField.value}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.props.secondLastNameField.error}
                                           onChange={this.props.onChangeSecondLastName}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <DatePicker label={LOAN_APPLICATION_MX.BIRTH_DATE}
                                            id={INPUTS.BIRTH_DATE}
                                            value={this.props.birthDateField.value}
                                            required={true}
                                            hasError={this.state.showErrors}
                                            labelError={this.props.birthDateField.error}
                                            onChange={this.props.onChangeBirthDate}
                                            minYearAllowed={this.props.minAllowedAge}
                                            maxYearAllowed={69}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.RFC_WITH_HOMOKEY}
                                           id={INPUTS.DOC_NUMBER}
                                           value={this.props.docNumberField.value}
                                           maxLength={13}
                                           minLength={13}
                                           required={true}
                                           hasError={this.state.showErrors || this.props.showRFCError}
                                           labelError={this.props.docNumberField.error}
                                           onChange={this.props.onChangeDocNumber}/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <InputText label={LOAN_APPLICATION_MX.CELL_PHONE}
                                           id={INPUTS.CELL_PHONE}
                                           value={this.props.cellPhoneField.value}
                                           maxLength={10}
                                           minLength={10}
                                           required={true}
                                           hasError={this.state.showErrors}
                                           labelError={this.props.cellPhoneField.error}
                                           type={InputTextTypes.NUMBER}
                                           onChange={this.props.onChangeCellPhone}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.GENDER}
                                    label={LOAN_APPLICATION_MX.GENDER}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.genderField.value}
                                    data={this.props.crGenderCatalog}
                                    required={true}
                                    onChange={this.props.onChangeGender}
                                    labelError={this.props.genderField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.CIVIL_STATUS}
                                    label={LOAN_APPLICATION_MX.CIVIL_STATUS}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.civilStatusField.value}
                                    data={this.props.crCivilStatusCatalog}
                                    required={true}
                                    onChange={this.props.onChangeCivilStatus}
                                    labelError={this.props.civilStatusField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.NATIONALITY}
                                    label={LOAN_APPLICATION_MX.NATIONALITY}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.nationalityField.value}
                                    data={this.props.nationalities}
                                    required={true}
                                    onChange={this.props.onChangeNationality}
                                    labelError={this.props.nationalityField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.STUDIES}
                                    label={LOAN_APPLICATION_MX.STUDIES}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.studiesLevelField.value}
                                    data={this.props.crStudiesLevelCatalog}
                                    required={true}
                                    onChange={this.props.onChangeStudiesLevel}
                                    labelError={this.props.studiesLevelField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <SelectSearchComponent
                                    id={INPUTS.ECONOMIC_DEPENDENTS}
                                    label={LOAN_APPLICATION_MX.ECONOMIC_DEPENDENTS}
                                    placeholder={GLOBAL.SELECT}
                                    value={this.props.economicDependentsField.value}
                                    data={this.props.economicDependentsCatalog}
                                    required={true}
                                    onChange={this.props.onChangeEconomicDependents}
                                    labelError={this.props.economicDependentsField.error}
                                    hasError={this.state.showErrors}/>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4">
                                <Options
                                    label={LOAN_APPLICATION_MX.ALREADY_HAS_VEHICLES}
                                    id={INPUTS.ALREADY_HAS_VEHICLES}
                                    name={INPUTS.ALREADY_HAS_VEHICLES}
                                    options={this.props.booleanOptions}
                                    onChange={this.props.onChangeAlreadyHasVehicle}
                                    orientation={OrientationTypes.HORIZONTAL}
                                    listGroupClass="list-group-borderless"
                                    required={true}
                                    labelError={this.props.alreadyHasVehicleField.error}
                                    hasError={this.state.showErrors}
                                    defaultValue={this.props.alreadyHasVehicleField.value.value}/>
                            </div>
                        </div>

                        <div className="mb-4 pb-2">
                            {this.renderMessage()}
                        </div>

                        <div className="border-bottom row">
                            <div className="col">
                                <Checkbox id={'acceptTerms'}
                                          name={'acceptTerms'}
                                          options={receiveNewsPromotionsOptions}
                                          onChange={this.onChangeReceiveNewsPromotions}
                                          hasError={this.state.showErrors}
                                          customClassLabel="text-initial"/>
                            </div>
                        </div>

                        <div className="row mt-4 mb-3">
                            <div className="col-12 d-flex justify-content-between">
                                <Button text={GLOBAL.BACK} onPress={this.props.onPressBack} role="button"
                                        customClass="left px-md-5 d-none d-md-block" type="outlined"/>

                                <Button text={LOAN_APPLICATION_MX.NEXT}
                                        onPress={this.onPressNext} role="button"
                                        customClass="right px-md-5 btn-block"/>
                            </div>
                        </div>

                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default PersonalDataStepView;
